export class EndLongStayRateCommand {
	id: number;
	endDate?: string;
}
